import { ArrowDown, ArrowUp } from "../keys";
import { listen } from "./events";

export function keyUpDown(
  node: Node,
  options: { up: (e: KeyboardEvent) => void; down: (e: KeyboardEvent) => void },
) {
  return keydown(node, (e) => {
    if (e.key == ArrowUp) options.up(e);
    if (e.key == ArrowDown) options.down(e);
  });
}

type KeyDownHandler = (e: KeyboardEvent) => void;
type KeyDownOptions = { condition?: boolean; handler: KeyDownHandler };
type KeyDownArguments = KeyDownHandler | KeyDownOptions;

export function keydown(node: Node, options: KeyDownArguments) {
  let _condition = "condition" in options ? options.condition : true;
  let _handler = "handler" in options ? options.handler : options;

  return {
    ...listen(node, {
      type: "keydown",
      handler: (e: KeyboardEvent) => {
        if (_condition) {
          _handler(e);
        }
      },
    }),
    update: (newOptions: KeyDownOptions) => {
      _condition = "condition" in newOptions ? newOptions.condition : true;
      _handler = "handler" in newOptions ? newOptions.handler : newOptions;
    },
  };
}

export function escape(node: Node, fn: (e: KeyboardEvent) => void) {
  return listen(node.ownerDocument, {
    type: "keydown",
    handler: (e: KeyboardEvent) => {
      if (e.key == "Escape") fn(e);
    },
  });
}
